import { EnvironmentVariable, SERVER_ENV_VARS_WINDOW_KEY } from '../constants/env'

export const getEnvVar = (envVar: EnvironmentVariable) => {
  if (process.env['NODE_ENV'] === 'production') {
    if (typeof window === 'undefined') {
      // Server side
      return process.env[envVar]
    }
    // Client side
    return (window as any)[SERVER_ENV_VARS_WINDOW_KEY][envVar]
  }
  return process.env[`NX_${envVar}`]!
}
